import { setAuthDATA } from "actions/authAction";
import "antd/dist/antd.css";
import React, {useEffect, useState} from "react";
import { connect } from "react-redux";
import { authenticationService } from "services/authentication/AuthenticationService";
import MainPage from "./components/main-page/MainPage";
import { permissionMenu } from './helpers/NewCaCrmHelper';
import "./index.css";
import { UserServices } from "./services/user/UserServies";
import LoadingComponent from "./components/common/loading/LoadingComponent";
import {BrowserRouter} from "react-router-dom";
const App: React.FC = (props: any) => {
  const [loading, setLoading] = useState(false);
  const getUser = async () => {
    const currentUser = authenticationService.currentUserValue;
    if (currentUser) {
      setLoading(true);
      const userService = new UserServices();
      const userResult = await userService.getUserAuth();
      let perList = await permissionMenu(userResult.data.permission_list);
      userResult.data.permission_list = perList
      props.setUserData(userResult.data);
      setLoading(false);
    }
  };

  useEffect(() => {
    getUser();
    // eslint-disable-next-line
  }, []);

  return (
    <BrowserRouter>
      {loading ? <LoadingComponent fullScreen={true} /> : ""}
      <div className="App">
        <MainPage></MainPage>
      </div>
    </BrowserRouter>
  );
};

function mapStateToProps(state) {
  const { authReducer } = state;
  return { userData: authReducer };
}

function mapDispatchToProps(dispatch) {
  return({
    setUserData: (userData) => {dispatch(setAuthDATA(userData))}
  })
}

export default connect(mapStateToProps,mapDispatchToProps)(App);
